import { HOME, PROFILE, USERS } from "../routes";

export const MenuItems = {
  EMPLOYEE: [
    { name: "Home", route: HOME },
    { name: "Profile", route: PROFILE },
  ],
  ADMIN: [
    { name: "Home", route: HOME },
    { name: "Profile", route: PROFILE },
    { name: "Users", route: USERS },
  ],
};
